import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { apiFetch, getTheme, uploadToS3 } from 'helpers'
import { get, isEqual } from 'lodash'

import Section, { SectionHeader, SectionHeaderText } from './Section'
import svgLoadingTiffany from 'assets/svg/icon-loading-tiffany.svg'
import { Overlay, ConfirmDialog } from 'components/Modal'

@connect()
export default class extends Component {
  constructor (props) {
    super(props)
    this.state = {
      deleting: false,
      packages: get(props, 'me.packages') || []
    }
  }

  componentWillReceiveProps (nextProps) {
    if (!isEqual(get(this.props, 'me.packages'), get(nextProps, 'me.packages'))) {
      this.setState({
        packages: get(nextProps, 'me.packages') || []
      })
    }
  }

  _onProgress = (e, file) =>
    this.setState({
      packages: this.state.packages.map(pkg =>
        get(pkg, 'file.name') === get(file, 'name') ? {
          ...pkg,
          percent: (100 * e.loaded / e.total).toFixed(0)
        } : pkg
      )
    })

  _onPackageChosen = (e) => {
    const files = Object.keys(e.target.files).map(key => e.target.files[key])
    this.setState({
      packages: (this.state.packages || [])
        .concat(files.map(file => ({ file, name: file.name, uploading: true }))
        ),
      showAll: true
    }, () =>
      files.reduce((promise, file, index) =>
        promise.then(() =>
          apiFetch({
            method: 'POST',
            v4: true,
            url: '/v4/s3/signed-url',
            body: {
              collectionName: 'vendors',
              folderName: `${get(this.props, 'me._id')}/packages`,
              fileName: file.name,
              fileType: file.type
            }
          })
            .then(({ url }) => uploadToS3({ url, file }))
            .then(filePath => new Promise(resolve => {
              if (file.type.indexOf('image') > -1) {
                const img = new window.Image()
                img.onload = () => resolve({ filePath, ratioW2H: img.width / img.height })
                img.src = (window.URL || window.webkitURL).createObjectURL(file)
              } else {
                resolve({ filePath })
              }
            }))
            .then(({ filePath, ratioW2H }) => {
              return apiFetch({
                method: 'POST',
                v4: true,
                url: '/v4/vendors/me/packages',
                body: {
                  name: file.name,
                  path: filePath,
                  ratioW2H
                }
              })
                .then(pkg => {
                  this.setState({
                    packages: this.state.packages.map(_pkg =>
                      _pkg.name === get(pkg, 'name') ? pkg : _pkg
                    )
                  })
                })
            })
        )
        , Promise.resolve())
    )
  }

  _onDelete = () => {
    if (this.state.deleting) return
    this.setState({ deleting: true },
      () => apiFetch({
        method: 'DELETE',
        v4: true,
        url: `/v4/vendors/me/packages/${this.state.deletingPackageId}`
      })
        .then(result => this.setState({
          packages: (this.state.packages || []).filter(pkg => pkg._id !== result._id),
          deleting: false,
          confirmVisible: false
        }))
        .catch(error => this.setState({ error, deleting: false }))
    )
  }

  render () {
    return (
      <Section style={{ borderTop: 0 }}>
        <SectionHeader>
          <SectionHeaderText style={{ textAlign: 'left' }}>Packages</SectionHeaderText>
          <section>
            {(this.state.packages || [])
              .map((pkg, index) =>
                <Package key={index}
                  onDelete={() => this.setState({ confirmVisible: true, deletingPackageId: pkg._id })}
                  pkg={pkg} />
              )}
          </section>
          <Overlay visible={this.state.confirmVisible}
            onClose={() => this.setState({ confirmVisible: false })}>
            <ConfirmDialog title='คุณต้องการลบแพ็กเกจนี้ ?'
              loading={this.state.deleting}
              onOkay={this._onDelete}
              onCancel={() => this.setState({ confirmVisible: false })} />
          </Overlay>
          <AddPackageRow>
            <AddPackageRowTitle>อัพโหลด Package</AddPackageRowTitle>
            <AddPackageRowDescription>ไฟล์ต้องเป็น PDF หรือรูปภาพเท่านั้น</AddPackageRowDescription>
            <BtnAddPackage
              action='add-package'
              onClick={() => ReactDOM.findDOMNode(this.refs.packageChooser).click()}>
              <span>เลือกไฟล์</span>
              <input type='file' ref='packageChooser'
                multiple
                accept='application/pdf,image/*'
                onChange={this._onPackageChosen}
                style={{ display: 'none' }} />
            </BtnAddPackage>
          </AddPackageRow>
        </SectionHeader>
      </Section>
    )
  }
}

const AddPackageRow = styled.div`
  position: relative;
  margin-top: 10px;
  text-align: right;
`
const AddPackageRowTitle = styled.div`
  font-family: ${getTheme`font1`};
  font-weight: ${getTheme`weightMedium`};
  font-size: 16px;
  color: black;
  line-height: 20px;
  padding-right: 130px;
`
const AddPackageRowDescription = styled.div`
  font-family: ${getTheme`font1`};
  font-size: 14px;
  color: ${getTheme`colorGray300`};
  line-height: 20px;
  padding-right: 130px;
`

const BtnAddPackage = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
  width: 120px;
  height: 40px;
  line-height: 40px;
  text-align: center;

  background-color: ${getTheme`colorTiffanyDark`};
  color: white;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
  transition: opacity 0.3s ease;
  &:hover { opacity: 0.8; }
  > svg {
    width: 14px;
    height: 14px;
    vertical-align: middle;
  }
  > svg > path { fill: white;}
  > span { margin-left: 10px; }
`

class Package extends Component {
  _clean = (string = '') =>
    string.replace('.bmp.bmp', '.bmp')
      .replace('.jpg.jpg', '.jpg')
      .replace('.png.png', '.png')
      .replace('.pdf.pdf', '.pdf')
      .replace('.gif.gif', '.gif')

  render () {
    const { pkg, onDelete } = this.props
    const cleanedPath = this._clean(get(pkg, 'path'))
    return (
      <PackageRow>
        <PackageIconWrapper />
        <PackageName ref='packageName'>{get(pkg, 'name')}</PackageName>
        {get(pkg, 'uploading') ? (
          <LoadingWrapper>
            <IconLoading src={svgLoadingTiffany} />
          </LoadingWrapper>
        ) : (
          <Wrapper>
            <BtnOpenPackage>
              <a style={{ textDecoration: 'none' }} target='_blank' href={cleanedPath}>เปิดดู</a>
            </BtnOpenPackage>
            <BtnDelete onClick={onDelete}>ลบ</BtnDelete>
          </Wrapper>
        )}
      </PackageRow>
    )
  }
}

const PackageRow = styled.div`
  position: relative;
  padding: 15px 0px;
  border-bottom: 1px solid ${getTheme`colorBorder`};
  &:last-child {
    margin-bottom: 30px;
  }
`
const PackageIconWrapper = styled.div`
  display: inline-block;
  vertical-align: top;
  margin-right: 15px;
  > svg {
    vertical-align: middle;
    width: 20px;
    height: 20px;
  }
  > svg > path {
    fill: black;
  }
  @media(max-width: 767px) {
    display: none;
  }
`
const PackageName = styled.div`
  font-family: ${getTheme`font1`};
  font-size: 16px;
  word-wrap: break-word;
  @media(min-width: 768px) {
    display: inline-block;
    vertical-align: top;
    width: calc(100% - 220px);
    padding-right: 5px;
    line-height: 40px;
  }
  @media(max-width: 767px) {
    display: block;
    margin-bottom: 10px;
  }
`
const Wrapper = styled.div`
  @media(min-width: 768px) {
    display: inline-block;
    vertical-align: top;
    width: 200px;
  }
  @media(max-width: 767px) {
    display: block;
  }
`
const LoadingWrapper = styled(Wrapper)`
  @media(min-width: 768px) {
    text-align: right;
  }
`

const Button = styled.div`
  display: inline-block;
  vertical-align: top;
  margin-right: 10px;
  width: 88px;
  height: 40px;
  line-height: 40px;
  border-radius: 5px;
  text-align: center;
  font-family: ${getTheme`font1`};
  font-weight: ${getTheme`weightSemiBold`};
  cursor: pointer;
  transition opacity 0.3s ease;
  &:hover { opacity: 0.8;}
  @media(min-width: 768px) {
    font-size: 18px;
  }
  @media(max-width: 767px) {
    font-size: 16px;
  }
`
const BtnOpenPackage = styled(Button)`
  border: 1px solid ${getTheme`colorTiffanyDark`};
  color: ${getTheme`colorTiffanyDark`};
  > a {
    display: block;
    color: ${getTheme`colorTiffanyDark`};
  }
`
const BtnDelete = styled(Button)`
  border: 1px solid ${getTheme`colorCoral`};
  color: ${getTheme`colorCoral`};
`
const IconLoading = styled.img`
  width: 30px;
  height: 30px;
  vertical-align: top;
  margin-top: 5px;
  margin-right: 10px;
`



// WEBPACK FOOTER //
// ./src/components/profile/SectionPackages.js